import CustomEvent from '@/common/models/customEvents/CustomEvent';
import API from '@/org-app/api';
import {
  createApiAction,
  createDeleteAction,
  createGetAllAction,
  createGetOneAction,
  createPostAction,
  createPutAction,
} from '@/utils/ActionsUtils';

import * as types from './mutation-types';

export default {
  createNewCustomEvent(
    { commit },
    customEvent = CustomEvent.fromObject({
      id: -1,
    }),
  ) {
    commit(types.CREATE_CUSTOMEVENT, customEvent);
    return customEvent;
  },
  getCustomEvents: createGetAllAction(
    API.instance.getCustomEvents,
    types.UPDATE_CUSTOMEVENTS_LIST,
    'messages.failedToGetCustomEvents',
    true,
  ),
  getCustomEvent: createGetOneAction(
    API.instance.getCustomEvent,
    types.UPDATE_CUSTOMEVENT,
    'messages.failedToGetCustomEvent',
  ),
  createCustomEvents: createPostAction(
    API.instance.postCustomEvents,
    types.SAVE_CUSTOMEVENTS,
    'messages.failedToCreateCustomEvent',
  ),
  updateCustomEvent: createPutAction(
    API.instance.putCustomEvent,
    types.SAVE_CUSTOMEVENTS,
    'messages.failedToUpdateCustomEvent',
  ),
  deleteCustomEvent: createDeleteAction(
    API.instance.deleteCustomEvent,
    types.DELETE_CUSTOMEVENT,
    'messages.failedToDeleteCustomEvent',
  ),
  getCustomEventsActivationStatus: createApiAction(API.instance.getCustomEventsActivationStatus),
  activateCustomEvents: createApiAction(API.instance.activateCustomEvents),
};
